import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import Tooltip from "@material-ui/core/Tooltip";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import FormGroup from "@material-ui/core/FormGroup";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";

import PopupMessage from "../components/PopupMessage";
import ConfirmDialog from "../components/ConfirmDialog";
import CustomTableHead from "../components/CustomTableHead";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomPaginatorActions from "../components/CustomPaginatorActions";

//import CircularProgress from "@material-ui/core/CircularProgress";

import {
  DRAWER_WIDTH,
  ACCOUNTS_TOOLBAR_HEIGHT,
  ACCOUNTS_TOOLBAR_TOP,
  MAIN_CONTENT_TOP,
  ROWS_PER_PAGE_OPTIONS,
  BACKEND_DATE_FORMAT,
} from "../components/Constants";
import {
  getSorting,
  getNumberSorting,
  getFloatSorting,
} from "../components/Utils";
import { getErrorString } from "../display/ErrorStrings";
import UploadedFileDetails from "../details/UploadedFileDetails";
import UploadItems from "../details/UploadItems";
import BulkUpload from "../details/BulkUpload";
import ViewPdf from "../components/ViewPdf";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import SearchIcon from "@material-ui/icons/PageviewOutlined";
import PDFViewIcon from "@material-ui/icons/PictureAsPdfOutlined";
import HistoryIcon from "@material-ui/icons/HistoryOutlined";
import ApproveIcon from "@material-ui/icons/GavelOutlined";
import BulkUploadIcon from "@material-ui/icons/CloudUploadOutlined";
import UploadIcon from "@material-ui/icons/CreateNewFolderOutlined";
import PayIcon from "@material-ui/icons/CheckOutlined";
import ReturnIcon from "@material-ui/icons/CloseOutlined";
import { Portal } from "react-overlays";

const CalendarContainer = ({ children }) => {
  const el = document.getElementById("calendar-portal");

  return <Portal container={el}>{children}</Portal>;
};

const columnData = [
  { id: "importId", numeric: false, disablePadding: true, label: "Import ID" },
  { id: "date", numeric: false, disablePadding: true, label: "Date" },
  { id: "fileName", numeric: false, disablePadding: true, label: "File Name" },
  {
    id: "numIssued",
    numeric: false,
    disablePadding: true,
    label: "Count Issued",
  },
  {
    id: "totalAmountIssued",
    numeric: true,
    disablePadding: false,
    label: "Amount Issued",
  },
  { id: "numVoid", numeric: false, disablePadding: true, label: "Count Void" },
  {
    id: "totalAmountVoid",
    numeric: true,
    disablePadding: false,
    label: "Amount Void",
  },
  {
    id: "firstCheckNumber",
    numeric: false,
    disablePadding: true,
    label: "First Check",
  },
  {
    id: "lastCheckNumber",
    numeric: false,
    disablePadding: true,
    label: "Last Check",
  },
  {
    id: "presenter",
    numeric: false,
    disablePadding: true,
    label: "Presented by",
  },
  {
    id: "importState",
    numeric: false,
    disablePadding: true,
    label: "Import Status",
  },
  {
    id: "approveAction",
    numeric: false,
    disablePadding: true,
    label: "Approval Status",
  },
];

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },

  vCenterItems: {
    display: "flex",
    alignItems: "center",
  },

  toolbar: {
    height: `${ACCOUNTS_TOOLBAR_HEIGHT}px`,
    zIndex: 1,
    position: "fixed",
    top: `${ACCOUNTS_TOOLBAR_TOP + ACCOUNTS_TOOLBAR_HEIGHT + 10}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
  },

  tableWrapper: {
    overflowX: "auto",
    overflowY: "auto",

    position: "fixed",
    top: `${MAIN_CONTENT_TOP + ACCOUNTS_TOOLBAR_HEIGHT}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
    bottom: "0px",
  },

  formContent: {
    marginTop: `50px`,
    position: "absolute",
    marginLeft: "50px",
    marginRight: "50px",
  },

  redCell: {
    color: "red",
  },
  boldCell: {
    fontWeight: "bold",
    fontSize: 14,
  },
  disabledButton: {
    backgroundColor: theme.palette.secondary.main,
    fontWeight: "bold",
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "secondary",
      cursor: "pointer",
    },
  },
});

class UploadItemsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      order: "asc",
      orderBy: "",
      page: 0,
      rowsPerPage: window.sco_large_items_per_page,
      startDate: null,
      redrawStartDate: false,
      redrawEndDate: false,
      endDate: null,
      backendStartDate: "",
      backendEndDate: "",
      totalCount: 0,
      totalAmount: "",
      items: [],
      reply: {},
      viewPopup: false,
      notifyString: "",
      viewPdf: false,
      canSearch: false,
      action: 0,
      selectedItemIndex: -1,
      selectedItem: {},
      acceptDisposition: true,
      confirmDisposition: false,
    };
    this.onClosePopup = this.onClosePopup.bind(this);
    this.onCloseUpload = this.onCloseUpload.bind(this);
    this.handleBulkDisposition = this.handleBulkDisposition.bind(this);
    this.onItemDisposition = this.onItemDisposition.bind(this);
  }

  componentDidMount() {
    fetch("on_check_Locked_item", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
            this.setState({ viewPopup: true });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  componentDidUpdate() {
    if (this.state.redrawStartDate) {
      this.setState({ redrawStartDate: false });
    }
    if (this.state.redrawEndDate) {
      this.setState({ redrawEndDate: false });
    }
  }

  disableSearch() {
    this.setState({ canSearch: false });
    this.setState({ page: 0 });
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ viewPdf: false });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
    this.setState({ selectedItemIndex: -1 });
  }

  onCloseUpload(e) {
    this.setState({ action: 0 });
  }

  onItemDisposition(e) {
    let newItems = this.state.items;
    newItems.splice(this.getItemIndex(this.state.selectedItemIndex), 1);
    this.setState({ items: newItems });
    let totCount = this.state.totalCount - 1;
    this.setState({ selectedItemIndex: -1 });
    this.setState({ totalCount: totCount });
  }

  handleBulkDisposition(e, action) {
    this.setState({ confirmDisposition: false });
    // confirmed
    if (action === 1) {
      let myImportIds = new Array(this.state.items.length);
      let i;
      for (i = 0; i < this.state.items.length; i++) {
        myImportIds[i] = this.state.items[i].importId;
      }
      fetch("on_uploaded_items_disposition", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          transit: this.props.accountObject.transit,
          account: this.props.accountObject.account,
          approval: this.state.acceptDisposition,
          importIds: myImportIds,
          secureToken: this.props.secureToken,
        }),
      })
        .then(function (res) {
          if (!res.ok) {
            throw Error(res.status + " (" + res.statusText + ")");
          }
          return res;
        })
        .then((res) => res.text())
        .then((text) => {
          var reply = JSON.parse(text);
          if (!reply.authenticated) {
            this.props.history.push("/expired");
          } else if (reply.error) {
            this.setState({ errorString: reply.errorString });
            this.setState({ viewPopup: true });
          } else {
            this.setState({ totalCount: 0 });
          }
        })
        .catch((error) => {
          this.setState({
            errorString:
              getErrorString(
                "general.server.status.error",
                "The server responded with a status of "
              ) + error.message,
          });
          this.setState({ viewPopup: true });
        });
    }
  }

  handleBulkAccept(e) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    this.setState({ acceptDisposition: true });
    this.setState({ confirmDisposition: true });
  }

  handleBulkReject(e) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    this.setState({ acceptDisposition: false });
    this.setState({ confirmDisposition: true });
  }

  handleSelectItem(event, itemIndex) {
    let myItems = this.state.items;
    this.setState({ selectedItemIndex: itemIndex });
    this.setState({ selectedItem: myItems[this.getItemIndex(itemIndex)] });
  }

  handleActions(event, selectedAction) {
    this.setState({ totalCount: 0 });
    this.setState({ page: 0 });
    this.setState({ orderBy: "" });
    this.setState({ action: selectedAction });
    this.setState({ selectedItemIndex: -1 });
    if (selectedAction === 2) {
      this.search(0, this.state.rowsPerPage, false, true);
    }
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
    if (this.state.canSearch) {
      this.search(page, this.state.rowsPerPage, true, false);
    }
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
    window.sco_large_items_per_page = event.target.value;
    if (this.state.canSearch) {
      this.search(this.state.page, event.target.value, true, false);
    }
  };

  handleRequestSort = (event, property) => {
    if (property.indexOf("nosort") !== -1) {
      return;
    }
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === property) {
      if (this.state.order === "desc") {
        order = "asc";
      }
    } else {
      order = this.state.order;
    }
    this.setState({ order, orderBy });
    this.sort(orderBy, order, this.state.items);
  };

  sort(orderBy, order, data) {
    if (orderBy.length > 0 && order.length > 0) {
      if (
        orderBy === "numIssued" ||
        orderBy === "numVoid" ||
        orderBy === "firstCheckNumber" ||
        orderBy === "lastCheckNumber"
      ) {
        data.sort(getNumberSorting(order, orderBy));
      } else if (orderBy === "totalAmountIssued") {
        data.sort(getFloatSorting(order, "rowTotalAmountIssued"));
      } else if (orderBy === "totalAmountVoid") {
        data.sort(getFloatSorting(order, "rowTotalAmountVoid"));
      } else {
        data.sort(getSorting(order, orderBy));
      }
      this.setState({ items: data });
    }
  }

  handleStartDate(date) {
    this.disableSearch();
    this.setState({ startDate: date });
    if (date === null) {
      this.setState({ backendStartDate: "" });
    } else {
      this.setState({ backendStartDate: date.format(BACKEND_DATE_FORMAT) });
    }
  }

  handleStartDateOutsideClick(e) {
    this.setState({ redrawStartDate: true });
  }

  handleEndDate(date) {
    this.disableSearch();
    this.setState({ endDate: date });
    if (date === null) {
      this.setState({ backendEndDate: "" });
    } else {
      this.setState({ backendEndDate: date.format(BACKEND_DATE_FORMAT) });
    }
  }

  handleEndDateOutsideClick(e) {
    this.setState({ redrawEndDate: true });
  }

  handlePdf(e) {
    if (!this.validateDates()) {
      return;
    }
    this.setState({ viewPdf: true });
  }

  handleSearch(e) {
    if (!this.validateDates()) {
      return;
    }
    this.setState({ page: 0 });
    this.setState({ orderBy: "importId" });
    this.setState({ order: "desc" });
    this.setState({ canSearch: true });
    this.search(0, this.state.rowsPerPage, true, false);
  }

  validateDates() {
    let start = this.state.startDate;
    let end = this.state.endDate;
    if (start !== null && end !== null && end.isBefore(start, "day")) {
      this.setState({
        errorString: getErrorString(
          "general.error.endDate",
          "End Date is before Start Date"
        ),
      });
      this.setState({ viewPopup: true });
      return false;
    }
    return true;
  }

  search(page, rowsPerPage, sortIt, approve) {
    fetch("on_uploaded_items_search", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        approval: approve,
        startDate: this.state.backendStartDate,
        endDate: this.state.backendEndDate,
        page: page,
        rowsPerPage: rowsPerPage,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          this.setState({ reply: reply });
          let newItems = reply.items;
          this.setState({ items: newItems });
          this.setState({ totalCount: reply.totalCount });
          if (sortIt) {
            this.sort(this.state.orderBy, this.state.order, newItems);
          }
          if (reply.totalCount === 0) {
            this.setState({ viewPopup: true });
            this.setState({
              notifyString: getErrorString(
                "general.info.search.empty",
                "Total number of items is 0."
              ),
            });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ totalCount: 0 });
        this.setState({ viewPopup: true });
      });
  }

  getItemIndex(objectIndex) {
    let items = this.state.items;
    let i;
    for (i = 0; i < items.length; i++) {
      if (items[i].index === objectIndex) {
        return i;
      }
    }
    return objectIndex;
  }

  isSelected = (id) => this.state.selectedStopKey === id;

  getSearchObject(page, rowsPerPage) {
    let data = {
      r: new Date().getTime(),
      secureToken: this.props.secureToken,
      transit: this.props.accountObject.transit,
      account: this.props.accountObject.account,
      startDate: this.state.backendStartDate,
      endDate: this.state.backendEndDate,
      rowsPerPage: this.state.rowsPerPage,
      page: this.state.page,
    };
    return data;
  }

  render() {
    const { classes } = this.props;
    let { t } = this.props;
    const { order, orderBy, rowsPerPage, page } = this.state;
    let data = this.state.items;
    let totalCount = this.state.totalCount;
    const datePickerTopMargin = 6;

    let myPdfUrl = "on_uploaded_items_pdf_request";
    /*let myPdfUrl = 'on_uploaded_items_pdf_request?transit=' +
			this.props.accountObject.transit +
			'&account=' + this.props.accountObject.account;
		if (this.state.backendStartDate.length > 0) {
			myPdfUrl += "&startDate=" + encodeURIComponent(this.state.backendStartDate);
		}
		if (this.state.backendEndDate.length > 0) {
			myPdfUrl += "&endDate=" + encodeURIComponent(this.state.backendEndDate);
		}*/
    return (
      <div id="myTopDiv">
        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewPopup && this.state.notifyString.length > 0 && (
          <PopupMessage
            title="Information"
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewPdf && (
          <ViewPdf
            history={this.props.history}
            secureToken={this.props.secureToken}
            onClosePopup={this.onClosePopup}
            postData={this.getSearchObject(page, rowsPerPage)}
            pdfUrl={myPdfUrl}
            page={page}
            rowsPerPage={rowsPerPage}
          />
        )}
        {this.state.confirmDisposition && (
          <ConfirmDialog
            title={
              this.state.acceptDisposition
                ? t("confirmBulkAccept.label")
                : t("confirmBulkReject.label")
            }
            text={
              this.state.acceptDisposition
                ? t("acceptAllItems.tip")
                : t("rejectAllItems.tip")
            }
            onCloseConfirm={this.handleBulkDisposition}
          />
        )}

        <div className={classes.toolbar}>
          <FormGroup row className={classes.vCenterItems}>
            <Typography variant="h6" color="primary">
              &nbsp;&nbsp; {t("uploadForPP.label")}
              &nbsp;&nbsp;
            </Typography>
            {this.props.accountObject.issuedFiles && (
              <Tooltip title={t("viewIssueHis.tip")}>
                <div>
                  <Button
                    color="primary"
                    classes={{
                      root: classes.button,
                      disabled: classes.disabledButton,
                    }}
                    onClick={(event) => this.handleActions(event, 1)}
                    disabled={this.state.action === 1}
                  >
                    <HistoryIcon />
                    &nbsp;{t("fileHis.button")}
                  </Button>
                </div>
              </Tooltip>
            )}
            {this.props.accountObject.uploadItems && (
              <Tooltip title={t("approveIssueItem.tip")}>
                <div>
                  <Button
                    color="primary"
                    classes={{
                      root: classes.button,
                      disabled: classes.disabledButton,
                    }}
                    onClick={(event) => this.handleActions(event, 2)}
                    disabled={this.state.action === 2}
                  >
                    <ApproveIcon />
                    &nbsp;{t("approve.button")}
                  </Button>
                </div>
              </Tooltip>
            )}
            {this.props.accountObject.uploadItems && (
              <Tooltip title={t("uploadInd.tip")}>
                <div>
                  <Button
                    color="primary"
                    classes={{
                      root: classes.button,
                      disabled: classes.disabledButton,
                    }}
                    onClick={(event) => this.handleActions(event, 3)}
                    disabled={this.state.action === 3}
                  >
                    <UploadIcon />
                    &nbsp;{t("uploadItems.button")}
                  </Button>
                </div>
              </Tooltip>
            )}
            {this.props.accountObject.uploadItems && (
              <Tooltip title={t("uploadBulk.tip")}>
                <div>
                  <Button
                    color="primary"
                    classes={{
                      root: classes.button,
                      disabled: classes.disabledButton,
                    }}
                    onClick={(event) => this.handleActions(event, 4)}
                    disabled={this.state.action === 4}
                  >
                    <BulkUploadIcon />
                    &nbsp;{t("bulkUpload.button")}
                  </Button>
                </div>
              </Tooltip>
            )}
          </FormGroup>
          <Divider />
        </div>
        <div className={classes.tableWrapper}>
          {this.state.action === 4 && (
            <BulkUpload
              history={this.props.history}
              accountObject={this.props.accountObject}
              viewOnly={this.props.viewOnly}
              secureToken={this.props.secureToken}
              onCloseUpload={this.onCloseUpload}
            />
          )}

          {this.state.action === 3 && (
            <UploadItems
              history={this.props.history}
              accountObject={this.props.accountObject}
              viewOnly={this.props.viewOnly}
              secureToken={this.props.secureToken}
              onCloseUpload={this.onCloseUpload}
            />
          )}

          {this.state.action === 1 && (
            <div>
              <FormGroup row>
                <Typography variant="h6" color="primary">
                  &nbsp;&nbsp; {t("issueFile.label")}
                  &nbsp;&nbsp;
                </Typography>
                <Typography variant="caption">
                  {t("startDate.label")}
                  {!this.state.redrawStartDate && (
                    <div style={{ marginTop: datePickerTopMargin }}>
                      <DatePicker
                        isClearable
                        disabledKeyboardNavigation
                        dateFormat="LL"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        selected={this.state.startDate}
                        onChange={(event) => this.handleStartDate(event)}
                        onClickOutside={(event) =>
                          this.handleStartDateOutsideClick(event)
                        }
                        popperContainer={CalendarContainer}
                      />
                    </div>
                  )}
                </Typography>
                &nbsp;&nbsp;
                <Typography variant="caption">
                  {t("endDate.label")}
                  {!this.state.redrawEndDate && (
                    <div style={{ marginTop: datePickerTopMargin }}>
                      <DatePicker
                        isClearable
                        disabledKeyboardNavigation
                        dateFormat="LL"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        selected={this.state.endDate}
                        onChange={(event) => this.handleEndDate(event)}
                        onClickOutside={(event) =>
                          this.handleEndDateOutsideClick(event)
                        }
                        popperContainer={CalendarContainer}
                      />
                    </div>
                  )}
                </Typography>
                <Tooltip title={t("searchIssue.tip")}>
                  <Button
                    color="primary"
                    onClick={(event) => this.handleSearch(event)}
                  >
                    <SearchIcon />
                    &nbsp;{t("search.button")}
                  </Button>
                </Tooltip>
                <Tooltip title={t("viewPdfReport.tip")}>
                  <Button
                    color="primary"
                    onClick={(event) => this.handlePdf(event)}
                  >
                    <PDFViewIcon />
                    &nbsp;{t("pdf.button")}
                  </Button>
                </Tooltip>
              </FormGroup>
              <TablePagination
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                page={page}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                ActionsComponent={CustomPaginatorActions}
              />

              {this.state.canSearch && this.state.totalCount > 0 && (
                <Paper>
                  <Table
                    className={classes.table}
                    aria-labelledby="tableTitle"
                    stickyHeader
                  >
                    <CustomTableHead
                      order={order}
                      orderBy={orderBy}
                      columnData={columnData}
                      onRequestSort={this.handleRequestSort}
                    />
                    <TableBody>
                      {data.map((n) => {
                        return (
                          <TableRow key={n.index}>
                            <TableCell style={{ width: "8%", padding: 2 }}>
                              {n.importId}
                            </TableCell>
                            <TableCell style={{ width: "8%", padding: 0 }}>
                              {n.date}
                            </TableCell>
                            <TableCell style={{ width: "12%", padding: 0 }}>
                              {n.fileName}
                            </TableCell>
                            <TableCell style={{ width: "8%", padding: 0 }}>
                              {n.numIssued}
                            </TableCell>
                            <TableCell style={{ width: "8%" }} numeric={true}>
                              {n.totalAmountIssued}
                            </TableCell>
                            <TableCell style={{ width: "8%", padding: 0 }}>
                              {n.numVoid}
                            </TableCell>
                            <TableCell style={{ width: "8%" }} numeric={true}>
                              {n.totalAmountVoid}
                            </TableCell>
                            <TableCell style={{ width: "8%", padding: 0 }}>
                              {n.firstCheckNumber}
                            </TableCell>
                            <TableCell style={{ width: "8%", padding: 0 }}>
                              {n.lastCheckNumber}
                            </TableCell>
                            <TableCell style={{ width: "8%", padding: 0 }}>
                              {n.presenter}
                            </TableCell>
                            <TableCell style={{ width: "8%", padding: 0 }}>
                              {n.importState}
                            </TableCell>
                            <TableCell style={{ width: "8%", padding: 0 }}>
                              {n.approveAction}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                    {this.state.totalCount > 0 &&
                      (page + 1) * rowsPerPage >= this.state.totalCount && (
                        <TableFooter className={classes.boldCell}>
                          <TableRow>
                            <TableCell className={classes.boldCell} colSpan={3}>
                              Total
                            </TableCell>
                            <TableCell className={classes.boldCell}>
                              {this.state.reply.totalIssued}
                            </TableCell>
                            <TableCell className={classes.boldCell}>
                              {this.state.reply.totalAmount}
                            </TableCell>
                            <TableCell className={classes.boldCell}>
                              {this.state.reply.totalVoid}
                            </TableCell>
                            <TableCell className={classes.boldCell}>
                              {this.state.reply.totalAmountVoid}
                            </TableCell>
                          </TableRow>
                        </TableFooter>
                      )}
                  </Table>
                </Paper>
              )}
            </div>
          )}

          {this.state.action === 2 && this.state.totalCount > 0 && (
            <div>
              {this.state.selectedItemIndex !== -1 && (
                <UploadedFileDetails
                  item={this.state.selectedItem}
                  history={this.props.history}
                  secureToken={this.props.secureToken}
                  accountObject={this.props.accountObject}
                  onClosePopup={this.onClosePopup}
                  onItemDisposition={this.onItemDisposition}
                />
              )}
              {this.state.selectedItemIndex === -1 && (
                <div>
                  <FormGroup row>
                    <Typography variant="body1" color="textSecondary">
                      &nbsp;&nbsp; <strong>{t("bulkDecisions.label")}</strong>{" "}
                      &nbsp;&nbsp;
                    </Typography>
                    <Tooltip title={t("acceptAllItems.tip")}>
                      <Button
                        color="primary"
                        onClick={(event) => this.handleBulkAccept(event)}
                      >
                        <PayIcon />
                        &nbsp;{t("accept.button")}
                      </Button>
                    </Tooltip>
                    <Tooltip title={t("rejectAllItems.tip")}>
                      <Button
                        color="primary"
                        onClick={(event) => this.handleBulkReject(event)}
                      >
                        <ReturnIcon />
                        &nbsp;{t("reject.button")}
                      </Button>
                    </Tooltip>
                  </FormGroup>
                  <Paper>
                    <Table
                      className={classes.table}
                      aria-labelledby="tableTitle"
                    >
                      <TableHead>
                        <TableRow>
                          {columnData.map((column) => {
                            return (
                              <TableCell
                                key={column.id}
                                numeric={column.numeric}
                                padding={
                                  column.disablePadding ? "none" : "default"
                                }
                              >
                                {column.label}
                              </TableCell>
                            );
                          }, this)}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.map((n) => {
                          const isSelected = this.isSelected(n.index);
                          return (
                            <TableRow
                              hover
                              className={classes.tableRow}
                              onClick={(event) =>
                                this.handleSelectItem(event, n.index)
                              }
                              selected={isSelected}
                              key={n.index}
                              title={t("viewDetail.label")}
                            >
                              <TableCell style={{ width: "8%", padding: 2 }}>
                                {n.importId}
                              </TableCell>
                              <TableCell style={{ width: "8%", padding: 0 }}>
                                {n.date}
                              </TableCell>
                              <TableCell style={{ width: "12%", padding: 0 }}>
                                {n.fileName}
                              </TableCell>
                              <TableCell style={{ width: "8%", padding: 0 }}>
                                {n.numIssued}
                              </TableCell>
                              <TableCell style={{ width: "8%" }} numeric={true}>
                                {n.totalAmountIssued}
                              </TableCell>
                              <TableCell style={{ width: "8%", padding: 0 }}>
                                {n.numVoid}
                              </TableCell>
                              <TableCell style={{ width: "8%" }} numeric={true}>
                                {n.totalAmountVoid}
                              </TableCell>
                              <TableCell style={{ width: "8%", padding: 0 }}>
                                {n.firstCheckNumber}
                              </TableCell>
                              <TableCell style={{ width: "8%", padding: 0 }}>
                                {n.lastCheckNumber}
                              </TableCell>
                              <TableCell style={{ width: "8%", padding: 0 }}>
                                {n.presenter}
                              </TableCell>
                              <TableCell style={{ width: "8%", padding: 0 }}>
                                {n.importState}
                              </TableCell>
                              <TableCell style={{ width: "8%", padding: 0 }}>
                                {n.approveAction}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </Paper>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

UploadItemsPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(UploadItemsPage));
